// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3fvfK","paperContainer":"style_paperContainer__2SZE8","spaceCallout":"style_spaceCallout__12hT1","unorderedList":"style_unorderedList__1-FQq"};